<template>
  <div class="mangheshopgoodcate-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="addGoodCate"
                  type="success"
                  class="f-r">创建分类</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           stripe
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 创建 弹层 -->
    <Modal v-model="showCreatTypeModal"
           title="创建"
           @on-ok="createType('addCate')"
           :loading="loading">
      <Form :model="cate"
            ref="addCate"
            :rules="cateValidate"
            action="javascript:void(0)">
        <FormItem label="名称"
                  prop="title">
          <Input v-model="cate.title"
                 placeholder />
        </FormItem>
        <FormItem label="排序">
          <Input v-model="cate.sort" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "mangheshopgoodcate-list",
  data () {
    return {
      loading: true,
      dataloading: true,
      cate: {
        title: "", // 当前
        sort: "0"
      },
      formItem: {},
      tablelist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      //  规则
      cateValidate: {
        title: [
          {
            required: true,
            message: "名称必须填写",
            trigger: "blur"
          }
        ]
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          width: 80
        },
        {
          title: "名称",
          minWidth: 300,
          key: "title",
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  marginLeft: params.row.left + "px"
                }
              },
              params.row.title
            );
          }
        },
        {
          title: "操作",
          key: "action",
          width: 130,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.editType(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.removeType(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      showCreatTypeModal: false,
      currentId: 0 // 编辑，当前id
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
  },
  components: {},
  methods: {
    // 获取产品列表
    getTableList: function () {
      var self = this;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        key: this.formItem.key,
      };
      this.$api.mangheshopgoodcate.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    addGoodCate: function () {
      this.showCreatTypeModal = true;
      this.currentId = 0;
      this.cate.title = "";
      this.cate.sort = "0";
      this.thumblist = new Array();
    },
    // 编辑
    editType: function (id) {
      this.currentId = id;
      this.showCreatTypeModal = true;
      this.$api.mangheshopgoodcate.detail({ id: id }).then(res => {
        if (res.code == 200) {
          this.cate = res.result;
        }
      });
    },
    // 提交祝福
    createType: function (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let params = {
            title: this.cate.title, // 分类名称
            sort: this.cate.sort
          };
          if (
            this.currentId == null ||
            this.currentId == 0 ||
            this.currentId == ""
          ) {
            this.$api.mangheshopgoodcate.create(params).then(res => {
              if (res.code == 200) {
                this.showCreatTypeModal = false;
                this.getTableList();
              }
            });
          } else {
            params.id = this.currentId;
            this.$api.mangheshopgoodcate.edit(params).then(res => {
              if (res.code == 200) {
                this.showCreatTypeModal = false;
                this.getTableList();
              }
            });
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
          this.showCreatTypeModal = false;
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    removeType: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>是否确定删除该？</p>",
        onOk: () => {
          this.$api.mangheshopgoodcate
            .remove({
              id: id
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getTableList();
              }
            });
        }
      });
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        key: this.formItem.key
      };
      this.$api.mangheshopgoodcate.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
  }
};
</script>

